import React from 'react';
import { DateRangePicker } from '@heroui/react';
import { parseDate } from '@internationalized/date';
import { formatDateForISO } from '../../../../../utils/helpers';
import { LocationSelector } from './LocationSelector';
import { IAdditionalFilter, ReportType } from '../../../types/reportsTypes';

interface IDateRangeLocationFilterProps {
	dateRange: IAdditionalFilter['dateRange'];
	location: IAdditionalFilter['location'];
	maxDate?: Date;
	minDate?: Date;
	onDateRangeChange: (value: IAdditionalFilter['dateRange'] | null) => void;
	onLocationChange: (value: IAdditionalFilter['location']) => void;
	title?: string; // Optional header title
	reportType?: ReportType; // Optional prop to adjust available filters based on report type
}

export const DateRangeLocationFilter: React.FC<IDateRangeLocationFilterProps> = ({
	dateRange,
	location,
	maxDate,
	minDate = new Date('2022-01-01'),
	onDateRangeChange,
	onLocationChange,
	title,
	reportType,
}) => {
	return (
		<div className="flex flex-col space-y-2">
			{title && <span className="text-md font-medium text-msi-midblue-color-500 border-b pb-1">{title}</span>}
			<div className="flex flex-row w-full items-center">
				<span className="text-sm font-medium text-msi-midblue-color-500 w-1/3">Date Range:</span>
				<div className="flex items-center w-2/3">
					<DateRangePicker
						value={dateRange}
						onChange={onDateRangeChange}
						className="w-full rounded-none"
						size="sm"
						showMonthAndYearPickers
						minValue={minDate ? parseDate(formatDateForISO(minDate)) : undefined}
						maxValue={maxDate ? parseDate(formatDateForISO(maxDate)) : undefined}
						aria-label='Select Date Range'
					/>
				</div>
			</div>

			<div className="flex flex-row justify-evenly space-x-2">
				<LocationSelector value={location!} onChange={onLocationChange} reportType={reportType} />
			</div>
		</div>
	);
};
